import React, { useMemo } from "react";
import { Field } from "react-final-form";
import classNames from "classnames";
import { FieldLabel } from "./FieldLabel";

interface IPhoneInputFieldProps {
  classname?: string;
  label?: React.ReactNode;
  placeholder?: string;
  required?: boolean;
  name: string;
  width?: "fullwidth" | "medium" | "large" | "small" | "none";

  onBlur?: () => void;
}

export const PhoneInputField = ({
  classname,
  required,
  name,
  placeholder,
  label,
  width = "none",

  onBlur,
}: IPhoneInputFieldProps) => {
  const maxWidth = useMemo(() => {
    switch (width) {
      case "small":
        return 240;
      case "medium":
        return 320;
      case "large":
        return 480;
      default:
        return "none";
    }
  }, [width]);
  return (
    <Field name={name}>
      {({ input, meta: { touched, error } }) => (
        <div className={classNames("field", classname)}>
          {label && <FieldLabel required={required}>{label}</FieldLabel>}
          <div className="control">
            <input
              {...input}
              onBlur={(e)=>{
                input.onBlur(e)
                e.persist()
                onBlur?.()
              }}
              type="tel"
              placeholder={placeholder}
              className={classNames("input is-medium", {
                "is-danger": touched && error,
              })}
              style={{
                maxWidth,
              }}
            />
          </div>
          <p
            className={classNames("help", {
              "is-danger": touched && error,
              "is-hidden": !(touched && error),
            })}
          >
            {touched && error ? error : ""}
          </p>
        </div>
      )}
    </Field>
  );
};
